import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Dialog } from '../shared/dialog/Dialog';
import { ReportComplete } from '../shared/report/ReportComplete';

export const ReportCompleteDialog: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { t } = useTranslation('translation');
  const history = useHistory();
  const handleOKClick = useCallback(() => {
    const blockDialogPath = `/players/best-friends/optional-block/${id}`;
    history.replace(blockDialogPath);
  }, [id, history]);
  return (
    <Dialog title={t('dialog_report_success')}>
      <ReportComplete onConfirmClick={handleOKClick} />
    </Dialog>
  );
};
